import * as fabric from 'office-ui-fabric-react';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthType, logout, useAuthentication } from '..';

const Navbar: FunctionComponent = () => {
    const navigate = useNavigate();
    const authType = getAuthType();

    const styles = fabric.mergeStyleSets({
        leftItem: {
            color: fabric.getTheme().palette.themeDarkAlt
        },
        righItem: {
            paddingRight: '20px'
        },
        dropDownStyle: {
            color: fabric.getTheme().palette.themeDark
        },
        text: {
            paddingLeft: 10,
            fontSize: '50px',
            cursor: 'pointer'
        }
    });

    const stackTokens: fabric.IStackTokens = { childrenGap: 5 };

    const items = [
        {
            key: 'section1',
            itemType: fabric.ContextualMenuItemType.Section,
            sectionProps: {
                topDivider: true,
                bottomDivider: true,
                items: [
                    {
                        style: { height: '70px' },
                        onRenderIcon: () => <ContextualMenuHeader />,
                        key: 'fullName'
                    }
                ]
            }
        },
        {
            key: 'section2',
            itemType: fabric.ContextualMenuItemType.Section,
            sectionProps: {
                items: [
                    {
                        onClick: () => {
                            logout();
                        },
                        key: 'Logout',
                        text: 'Atsijungti',
                        iconProps: { iconName: 'UnlockSolid', style: { color: 'themePrimary' } }
                    }
                ]
            }
        }
    ].filter((x) => authType === 'Azure' || x.key === 'section1');

    return (
        <fabric.Stack style={{ width: '100%' }} horizontal tokens={stackTokens}>
            <fabric.Stack.Item grow className={styles.leftItem} align="center">
                <div>
                    <fabric.Text className={styles.text} onClick={() => navigate('/administration')} variant={'mega'}>
                        NUGIS
                    </fabric.Text>
                </div>
            </fabric.Stack.Item>
            <fabric.Stack.Item className={styles.righItem} align="center">
                <fabric.IconButton className={styles.dropDownStyle} primary onRenderChildren={() => <ContextualMenuHeader />} menuProps={{ items }} />
            </fabric.Stack.Item>
        </fabric.Stack>
    );
};

export const ContextualMenuHeader: FunctionComponent = () => {
    const { username } = useAuthentication();

    return (
        <div>
            <fabric.Persona size={fabric.PersonaSize.size48} text={username} secondaryText={username} />
        </div>
    );
};

export default Navbar;
